export const SurveyQuestionTypes = [
  {
    id: 1,
    name: "",
    label: "Single Choice",
    options: "",
    questionType: 'radiogroup',
    icon: 'fa-regular fa-circle-dot fa-fw' // was: fa-dot-circle-o
  },
  {
    id: 2,
    name: "",
    label: "Multi Choice",
    options: "",
    questionType: "checkbox",
    icon: "bi bi-check-square fa-fw" // Bootstrap icon
  },
  {
    id: 4,
    name: "",
    label: "Open Text",
    options: "",
    questionType: "openText",
    icon: "bi bi-square fa-fw" // Bootstrap icon
  },
    {
    id: 5,
    name: "",
    label: "Multi Text",
    options: "",
    questionType: "multiText",
    icon: "fa fa-align-left" 
  },
  {
    id: 18,
    name: "",
    label: "Numeric",
    options: "",
    questionType: 'numeric',
    icon: 'fa-solid fa-calculator fa-fw'
  },
  {
    id: 6,
    name: "",
    label: "NPS",
    options: "",
    questionType: "NPS",
    icon: "bi bi-speedometer fa-fw" // Bootstrap icon
  },
  {
    id: 3,
    name: "",
    label: "Select List",
    options: "",
    questionType: 'selectList',
    icon: 'fa-regular fa-square-caret-down fa-fw' // was: fa-caret-square-o-down
  },
  {
    id: 7,
    name: "",
    label: "Date",
    options: "",
    questionType: 'date',
    icon: 'fa-solid fa-calendar fa-fw'
  },
  {
    id: 8,
    name: "",
    label: "Rating",
    options: "",
    questionType: 'starRating',
    icon: 'fa-solid fa-star fa-fw'
  },
  {
    id: 9,
    name: "",
    label: "Emoji",
    options: "",
    questionType: 'rating',
    icon: 'fa-regular fa-face-smile fa-fw' // was: fa-smile-o
  },
  {
    id: 19,
    name: "",
    label: "Section",
    options: "",
    questionType: 'heading',
    icon: 'fa-solid fa-bars fa-fw'
  },
  {
    id: 10,
    name: "",
    label: "Ranking",
    options: "",
    questionType: 'ranking',
    icon: 'fa-solid fa-trophy'
  },
  {
    id: 11,
    name: "",
    label: "Single Selector",
    options: "",
    questionType: 'singleDropdown',
    icon: 'fa-solid fa-caret-down fa-fw'
  },
  {
    id: 12,
    name: "",
    label: "Multi Selector",
    options: "",
    questionType: 'multiselectdropdown',
    icon: 'fa fa-light fa-list-alt icon' // Changed from fa-light fa-list-alt (fa-light isn't default tier)
  },
  {
    id: 13,
    name: "",
    label: "Yes or No",
    options: "",
    questionType: 'boolean',
    icon: 'fa-solid fa-thumbs-up fa-fw'
  },
  {
    id: 14,
    name: "",
    label: "Slider Scale",
    options: "",
    questionType: 'sliderScale',
    icon: 'fa-solid fa-sliders fa-fw'
  },
  {
    id: 15,
    name: "",
    label: "Matrix Single Choice",
    options: "",
    questionType: 'matrix',
    icon: 'fa-solid fa-list fa-fw'
  },
  {
    id: 16,
    name: "",
    label: "Matrix Multi Choice",
    options: "",
    questionType: 'matrixmultiChoice',
    icon: 'fa-solid fa-th-large fa-fw'
  },
  {
  id: 20,
  name: "",
  label: "Matrix Option Choice",
  options: "",
  questionType: 'matrixOptionChoice',
  icon: 'fa-solid fa-square-caret-down fa-fw'
},

  {
    id: 17,
    name: "",
    label: "Image Selection",
    options: "",
    questionType: 'imagepicker',
    icon: 'fa-solid fa-camera fa-fw'
  }
  // Uncomment if needed
  // {
  //   id: 11,
  //   name: "",
  //   label: "Video Capture",
  //   options: "",
  //   questionType: 3,
  //   icon: 'fa-solid fa-video fa-fw'
  // }
];


// export const languageOptions=["English","Hindi","Telugu","Kannada","Tamil","Gujarathi"];
export const languageOptions = [
    { label: "English", value: "English", disabled: true },
    { label: "Hindi", value: "Hindi" },
    { label: "Telugu", value: "Telugu" },
    { label: "Kannada", value: "Kannada" },
    { label: "Tamil", value: "Tamil" },
    { label: "Gujarathi", value: "Gujarathi" }
  ];
export const localSurveyDefinition={
    "header": {
        "title": "",
        "description": "",
        "logoPosition": "right",
        "titlePosition": "center",
        "logo": "",
        "surveyheadingForeground": {
            "margin": "auto",
            "color": "#ffffff",
            "font-size": "27px"
        },
        "surveyheadingBackground": {
            "background-color": "#FF0000",
            "padding": "10px"
        },
        "headerErrorStatus": true
    },
    // "translations":{
    //     "languages":["English"]
    // },
    "footer": {
        "previousbuttonlabel": "<<",
        "previousbuttonstyle": {
            "background-color": "#0000FF"
        },
        "nextbuttonlabel": ">>",
        "nextbuttonstyle": {
            "background-color": "#0000FF"
        },
        "progressbar": true,
        "progressbarstyle": {
            "background-color": "#FFFFFF"
        },
        "footerBackgroundcolor": "#000000",
        "footerErrorStatus": false
    },
    "pages": [
        {
            "elements": [

            ]
        }
    ]
}